import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { RegistrationApi, type RegisterRequest, type RegisterResponse } from '@shared/api';
import { AuthUtils } from '@shared/utils';

const registerEffect = createEffect((request: RegisterRequest) => RegistrationApi.register(request));
const clearEvent = createEvent();

const $dataStore = createStore<RegisterResponse | null>(null)
  .on(registerEffect.done, (_, data) => {
    AuthUtils.setToken('registerToken', data.result.data?.token);
    return data.result.data || null;
  })
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(registerEffect.pending, (_, data) => data)
  .on(registerEffect.fail, () => false)
  .on(registerEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(registerEffect, () => null)
  .on(registerEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(registerEffect.done, () => null)
  .reset(clearEvent);

export const $registerStore = {
  events: {
    register: registerEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
